import axios from "axios";
import { isEmpty } from "lodash";
import Swal from "sweetalert2";
import CryptoJS from 'crypto-js';
import { GET_TRADE_YES_AND_NO, TRADE_MANAGE_RATE } from "../constant/endpoint";

let logoutTimeout;
const TIMEOUT_DURATION = 30 * 60 * 1000; // 30 minutes

const Match_Type = [
  'upcoming',
  'running',
  'cancelled',
  'completed',
  'delayed'
]
export const Match_Type_Tab = [
  'upcoming',
  'Match Delayed',
  'Live',
  'Result Pending',
  'Result'
]

export const SPORTS_TYPE = [
  {sport: 1, name: 'Cricket'},{sport: 4, name: 'Kabaddi'},{sport: 2, name: 'Football'}
]

export default Match_Type

export const getSweetAlert = (type, topic) => {
  Swal.fire({
    position: 'top-end',
    icon: type,
    title: topic,
    showConfirmButton: false,
    timer: 3000
  })
}

const resetLogoutTimeout = (logoutFunction) => {
  clearTimeout(logoutTimeout);
  logoutTimeout = setTimeout(logoutFunction, TIMEOUT_DURATION);
};

const logout = () => {
  localStorage.clear()
  window.location.href = '/login';
}

export const interCeptor = (token) => {
  axios.defaults.timeout = 300000;
  axios.interceptors.request.use(function (config) {
    // resetLogoutTimeout(logout);
    const getItem = localStorage.getItem('persist:prediction')
    console.log("getItem", getItem)
    const tokens = !isEmpty(getItem) ? JSON.parse(JSON.parse(getItem).loginSlice).token : ''
    Object.assign(config.headers, { authorize: tokens })
     console.log("config", config)
    return config;
  }, function (error) {
    return Promise.reject(error);
  });

  axios.interceptors.response.use(function (response) {
    return response;
  }, async function (error) {
    if (error.code === 'ECONNABORTED') {
      // console.error("❌ Request timed out");
      await getSweetAlert('error', "Request timed out!!");
    }else  if (error?.response?.data?.error === 'Session Token expired') {
      localStorage.removeItem('persist:prediction');
      return window.location.reload();
    }else
    await getSweetAlert('error', error?.response?.data?.error)
  });
}

export const predictionType = ['OPINION', 'OPINION PRO', 'TRADING', 'QUIZ PLAY', "SKILLER"]


export const showTradeRate = async (match_id, id, sport =1 ,showRate = true) => {
  const response = await axios.get(TRADE_MANAGE_RATE.replace(':match_id', match_id).replace(':prediction_id', id).replace('sport_id', sport))
  if (response?.data?.status === "success") {
    if (showRate) {
      Swal.fire({
        title: 'Yes / No',
        text: (response.data.data).join('/'),
        position: 'center'
      })
    }
    return response.data.data
  }
}

export const getTradeYesAndNo = async (id) => {
  const number = await Swal.fire({
    title: 'Enter The Count',
    input: 'number'
  })
  const result = await axios.get(GET_TRADE_YES_AND_NO.replace(':prediction_id', id).replace(':limit', number.value || 0))
  if (result?.data?.status === "success") {
    Swal.fire({
      position: 'top-end',
      title: `count = ${result?.data?.data?.count}`,
      icon: 'success',
      html: `<div>${result?.data?.data?.result} <hr /> 
          <span>YES/NO Rate :- ${result?.data?.data?.matchedResult?.rateRationByLast10Matched?.yes}/${result?.data?.data?.matchedResult?.rateRationByLast10Matched?.no}</span>
          </div>`,
      showConfirmButton: false,
      width: '100%'
    })
  }
}

{/* <span>Yes Investment:- ${result?.data?.data?.matchedResult?.investOnYes}</span> |
<span>No Investment:- ${result?.data?.data?.matchedResult?.investOnNo}</span> | */}


export const setTradeRate = async (tradeId, matchId, interval, sport = 1) => {
  await Swal.fire({
    title: `Enter The Rate For Yes`,
    text: 'Please enter a valid number between 0.5 and 9.5',
    input: 'number',
    inputAttributes: {
      min: 0.5,
      max: 9.5,
      step: interval
    },
    preConfirm: async (text) => {
      // Convert the entered text to a number
      const enteredNumber = parseFloat(text);
      // Check if the entered value is a valid number within the specified range
      if (!isNaN(enteredNumber) && enteredNumber >= 0.5 && enteredNumber <= 9.5) {
        let data = {'1': enteredNumber, '2': 10 -enteredNumber}
        const res = await axios.post(TRADE_MANAGE_RATE.replace(':match_id', matchId).replace(':prediction_id', tradeId).replace('sport_id', sport), data)
        if(res.data.status === "success"){
          return "success"
        }
      } else {
        Swal.showValidationMessage('Please enter a valid number between 0.5 and 9.5');
      }
    }
  });
}



export const decryptPassword= (encryptedText) => {
  try {
    const aesKeyMobile = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AESKEYMOBILE);
    const aesIVMobile = CryptoJS.enc.Base64.parse(process.env.REACT_APP_AESIVMOBILE);  

    const encryptedBase64 = encryptedText;
    const encrypted = CryptoJS.enc.Base64.parse(encryptedBase64);

    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encrypted },
      aesKeyMobile,
      {
        iv: aesIVMobile,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    let decoded = decrypted.toString(CryptoJS.enc.Utf8);
    if (decoded.startsWith('"') && decoded.endsWith('"')) {
      decoded = JSON.parse(decoded);  
    }
    return decoded;
  } catch (error) {
    console.log('request decrypt error >>', error);
    return "DecError";
  }
};

export const getNumberBeforeKeyword =(inputString, keyword = "score")=> {
  // Create a regular expression to match a number before the keyword
  const regex = new RegExp(`(?<=${keyword} )\\d+`, 'i');
  
  // Execute the regex to find the number
  const match = inputString.match(regex);
  
  // Return the matched number or null if not found
  return match ? match[0] : null;
}


